// PHASE 4: How confident are you in making design decisions?
import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'styleConfidence'

const OPTIONS = [
  {
    value: 'Very confident',
    translationKey: 'pages.onboarding.v2.styleConfidence.options.veryConfident',
    emoji: '💪',
  },
  {
    value: 'Somewhat confident',
    translationKey:
      'pages.onboarding.v2.styleConfidence.options.somewhatConfident',
    emoji: '🙂',
  },
  {
    value: 'Need guidance',
    translationKey: 'pages.onboarding.v2.styleConfidence.options.needGuidance',
    emoji: '🤔',
  },
  {
    value: 'Often second-guess myself',
    translationKey: 'pages.onboarding.v2.styleConfidence.options.secondGuess',
    emoji: '😬',
  },
  {
    value: 'Completely lost',
    translationKey: 'pages.onboarding.v2.styleConfidence.options.lost',
    emoji: '🆘',
  },
]

export default function StyleConfidencePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How confident are you in making design decisions?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v2.styleConfidence.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
